'use client'

import { useState, useRef, useEffect } from 'react'
import { CONTACTUS_COMPONENTS_MAPPING } from '@configs/contactus.config'
import AssistBot from '@components/AckoAssistBot/AssistBot'

const ContactUsView = ({ contents, isMobile, envConfig }) => {
  const botRef = useRef<any>(null)
  useEffect(() => {
    if (botRef.current) {
      botRef.current.setCopilotContext({ page: 'Contact Us' })
    }
  }, [])
  const [isModalOpen, setIsModalOpen] = useState(false)

  const triggerCopilot = message => {
    botRef.current.sendCopilotMessage(message)
  }
  const handleModalOpen = flag => {
    setIsModalOpen(flag)
    botRef.current?.closeCopilot()
  }

  return (
    <>
      {contents?.map(componentData => {
        const componentName = componentData.__component
        const Component = CONTACTUS_COMPONENTS_MAPPING[componentName]
        if (Component) {
          return (
            <Component
              key={componentData.id + componentName}
              {...componentData}
              isMobile={isMobile}
              isModalOpen={isModalOpen}
              handleModalOpen={handleModalOpen}
              triggerCopilot={triggerCopilot}
            />
          )
        }
        return null
      })}
      <AssistBot ref={botRef} hideFAB={isModalOpen} envConfig={envConfig} />
    </>
  )
}

export default ContactUsView
